/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![RecordPlayerIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAACUElEQVR4nMVVS2tTURCO4mOhKK7UqiDqSlcuXAhq6qIQTOZxhZOZNL5poyK0u1ZKMf4dtaD/QLAIVVTUjS4sKmh3omhFu6rMTW5ycpJ7E7vQAwM3M+fMN/PNI7nc/zzOue3Ach1Z5oD1PbIsI8kvIH2HpA+IKmPF4uiOtTjeBCS3gfQbsq5mCbB8BZKZfD6/YSDnxbOjB5D0eT/HGAiRnOzrPIqqe5HkQxDha2SZBNAjIyPntpS4ciIFYDjJPpUWJH3pPfpt/Nfr9fX+PYs0DaDElePA8qJWq23sAkDWWd85Yvm06QuFwmaMdAJYFuIip1M0bNL8PdvhvFCobgseX4vrUXR7gqxWBwGw5nDObfXSrlz1OTda4shpMOc9MjAZ9+iR+22DTMa6SCdaoKQrQDqFqEMmQDJtukwAkjstgMYQNQ3oDsc6kidtAJkOa2a6PgCLfoF/JoaEOyD9keiiqLq7GchjJJm37zPO7coCsAHsCWB93tWKqEPxPZJ5YH0UfxtdHXfKp6zzPKqX2wAki5nrgLopQpabHTUC3QksNY+iNylF7gWgKzHnaUWO9EYul1sHrA+9DOb8Nh37290DLJ/tXSkqHwszatj1Ytag9ZNPzHKwxQDq0cD5d/MZtt3MoAAlkvPBmhkPKJ3qvexYXg0EguULrcDAHQKSJY+6Z6kbtbF7Otc19u6qJSC5hKxXrBae7WMyM6mHSPYj6dM1FH2BSPZlOg/oumXT2D8b/WL1S6Ul61gnxMNDetf+6K07bOqB9S2w3EMsX+7qln99/gD/i5epefMozwAAAABJRU5ErkJggg==)
 */
export const RecordPlayerIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M18.03 2.8a11 11 0 1 0 2.52 2.28c-.28-.34-.8-.13-.8.31v7.37c0 1-.4 1.95-1.1 2.65l-.78.78a.6.6 0 0 0-.14.53c.08.53-.08 1.1-.5 1.52l-1 1a1.75 1.75 0 1 1-2.47-2.48l1-1c.42-.41.99-.57 1.52-.49.2.03.4 0 .53-.14l.78-.78c.42-.42.66-1 .66-1.6V3.22a.49.49 0 0 0-.22-.41ZM12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm-7-2a1 1 0 0 0 1-1 6 6 0 0 1 6-6 1 1 0 1 0 0-2 8 8 0 0 0-8 8 1 1 0 0 0 1 1Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
